import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Input } from "@angular/core";
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalFilterService } from '../../services/filters/global-filter.service';
import { HierarchyService } from '../../services/filters/hierarchy.service';
import { AccountsService } from "../../services/accounts/accounts.service";
import { SessionMgmtService } from "../../services/session-mgmt/session-mgmt.service";
import { HelpersService } from "../../services/helpers/helpers.service";
import { FeedsService } from "../../services/feeds/feeds.service";
import { extendedRaterFile } from "src/app/shared/services/external-ts-files/extended-rating-mapper";
import * as _ from 'lodash'
import * as moment from "moment";
import { NgIf, NgFor, NgStyle } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { LtmsTooltipDirective } from "../../components/ltms-tooltip/ltms-tooltip.directive";
import { OrderByPipe } from "../../pipes/order-by/order-by.pipe";
@Component({
    selector: 'app-ltms-global-filter-side-bar',
    templateUrl: './ltms-global-filter-side-bar.component.html',
    styleUrls: ['./ltms-global-filter-side-bar.component.scss'],
    imports: [NgIf, NgFor, NgStyle, FormsModule, LtmsTooltipDirective, OrderByPipe]
})
export class LtmsGlobalFilterSideBarComponent implements OnInit, OnDestroy {
  @ViewChild('hierarchySelector') hierarchySelector!: ElementRef;
  @ViewChild('globalfilter') globalfilter!: ElementRef;
  @ViewChild('savedfilter') savedfilter!: ElementRef;
  @Input() isAccount: boolean = false;
  loggedInUserLevel;
  loggedInUserValues;
  activeTab: string = "by_hierarchy"

  searchLevelNotFound: boolean = false;
  searchLevelText: any;
  project_id: string = '';
  fromDate: string = '';
  toDate: string = '';
  flag = false;

  // ---------------------------------------------------------
  levelDisplay = false;
  searchByHierarchyLevelAndValue: boolean = false;
  isSidebarOpen = false;
  showOverlay: boolean = false;
  hierarchyMapping: any = [];
  hierarchyFilterMapping: any = [];
  hierarchies_search: any = [];

  defaultAccess = {
    key: "",
    label: "Select level",
    options: ["ALL"],
    value: "ALL"
  };

  selectedLevel: any = {
    key: "",
    label: "Select level",
    options: ["ALL"],
    value: "ALL"
  };

  filters: any = [];
  defaultFilterObject: any = {
    filterType: "",
    fieldId: "",
    fieldText: "Select from the list or start by typing something",
    operator: "",
    isMultiSelect: false,
    isAllSelected: false,
    operatorText: "Select one",
    valueText: "Select",
    values: [],
    labels: [],
    details: [],
    filters: [],
    operators: [],
    possibleValues: []
  };

  currentFilter: any = {};
  tempFilter: any = {};
  showCurrentFilter: boolean = true;
  selectedFilters: any = [];
  appliedGlobalFilter: any = [];

  savedFilters: any = [];
  savedFiltersList: any = [];
  isSaveFilterModalOpen: boolean = false;
  filterName: string = "";
  enableSaveButton: boolean = false;
  dataIndex: any = ''
  dropdownId: string = "";
  dropdowndata: any = {};
  highlightType: string = "";

  projectId: any = null;
  accountId: any = null;
  isHierarchyFilterEnabled: boolean = (!this.isAccount) ? true : false;
  isUniversalFilterEnabled: boolean = true;
  isHuddleFilterEnabled: boolean = false;
  isActiveActionTab: boolean = false;
  hierarchyLevelAndValue: any = {
    selectLevel: false,
    selectValue: false,
  }
  hierarchyLevelAndValueDivId = "";
  hierarchyDrillDownDivId = "";
  childHierarchyIndex: any = '';
  manager_type: any = null;
  isApplyButtonEnabled: boolean = false;
  filterStore: any = []
  isHierarchFilterHidden: boolean = false;
  isEditAccess: boolean = false;
  saveFilterSearchText: string = '';

  isHuddleTabActive: boolean = false;

  extenderRatingMapper = new extendedRaterFile();
  
  constructor(
    private hierarchyService: HierarchyService,
    private globalFilterService: GlobalFilterService,
    private accountsService: AccountsService,
    private _sessionMgmtService: SessionMgmtService,
    private _helpers: HelpersService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _feedService: FeedsService
  ) {
    // Open hierarchy sidebar pop-up
    this.globalFilterService.openHierarchyFilter().subscribe((data) => {
      this.saveFilterSearchText = ''
      this.openSideBar(this, data);
    })

  }

  ngOnInit() {
    this.doEmpty();
    this.reloadComponent();
    // this._helpers.datePicker.subscribe((datePicker: any) => {
    //   if (datePicker && datePicker.startDate && datePicker.endDate) {
    //     this.fromDate = datePicker.startDate;
    //     this.toDate = datePicker.endDate;
    //     // this.doEmpty();
    //     // this.reloadComponent();
    //   }

    // })
    this.globalFilterService.hideHierarchyFilter.subscribe((flag) => {
      this.isHierarchFilterHidden = (flag == true) ? true : false;
    })

    this._route.queryParams.subscribe(params => {
      let url = this._router.url
      let routeData = this._helpers.prepareRouteData(url)
      let huddleTabsActive = (routeData && routeData.routeName && routeData.routeName == "huddle") ? true : false;
      // this code is added because hierarchy filter has diffrent behaviour for huddle.
      if (huddleTabsActive) {
        this.isHuddleTabActive = true;
        this.resetToCurentAcccess()
      } else if (this.isHuddleTabActive && routeData && routeData.routeName && routeData.routeName != "action") {
        this.isHuddleTabActive = false;
        this.resetToCurentAcccess()
      }
      if (routeData && routeData.routeName && routeData.routeName == "action") {
        this.isActiveActionTab = true;
      } else {
        this.isActiveActionTab = false;
      }
      if (this.accountId != params['account_id'] || this.projectId != params['project_id']) {
        this.projectId = params['project_id'];
        this.accountId = params['account_id'];
        this.isEditAccess = this.globalFilterService.hasFilterEditAccess(this.accountId)
      }
    });
  }
  ngAfterViewInit() {
    document.addEventListener('click', (event) => {
      const addFilterButton: any = document.getElementById('add-filter-button')
      const hierarchyFilterButton: any = document.getElementById('hierarchy-filter-button')
      const filterRule = (this.globalfilter && (this.globalfilter.nativeElement !== event.target && !this.globalfilter.nativeElement.contains(event.target)));
      const savefilterRule = (this.savedfilter && this.savedfilter.nativeElement !== event.target && !this.savedfilter.nativeElement.contains(event.target));
      let addButtonRule = (addFilterButton && addFilterButton !== event.target && !addFilterButton.contains(event.target));
      let hierarchyButtonRule = (hierarchyFilterButton && hierarchyFilterButton !== event.target && !hierarchyFilterButton.contains(event.target));
      if (!addFilterButton)
        addButtonRule = true

      if (!hierarchyFilterButton)
        hierarchyButtonRule = true;

      // Handle dropdown toggle if clicked anywhere
      // Hierarchy drilldown
      const hieDiv1: any = document.getElementById(this.hierarchyDrillDownDivId);
      if (hieDiv1 && !hieDiv1.contains(event.target) && !_.isEmpty(this.hierarchyMapping) && !_.isEmpty(this.hierarchyMapping[this.childHierarchyIndex])) {
        this.hierarchyMapping[this.childHierarchyIndex].isDropDownOpen = false
      }
      // Hierarchy search by level and value
      const hieDiv: any = document.getElementById(this.hierarchyLevelAndValueDivId);
      if (hieDiv && !hieDiv.contains(event.target) && !_.isEmpty(this.hierarchies_search)) {
        this.hierarchyLevelAndValue.selectLevel = false;
        this.hierarchyLevelAndValue.selectValue = false;
      }

      if (addButtonRule == true && hierarchyButtonRule == true && ((filterRule && savefilterRule) || (filterRule && this.savedfilter == undefined))) {
        // this.isSidebarOpen = false;
        this.closeSideBar();
      }
      const parentEl: any = document.getElementById(this.dropdownId);
      if (parentEl && !parentEl.contains(event.target) && !_.isEmpty(this.dropdowndata)) {
        const index = _.findIndex(this.selectedFilters, { fieldId: this.dropdowndata.fieldId });
        this.dropdownId = "";
        if (this.dropdowndata.isOptionDropDownOpen && this.currentFilter.isMultiSelect) {
          this.submitDropdownValue(this.currentFilter, this.dataIndex);
        }
        let defaultInput: any = document.getElementById('option_search_option_dropdown_current_filter');
        let fieldInput: any = document.getElementById('option_search_' + this.tempFilter.fieldId);
        let fieldInput2: any = document.getElementById('option_search_' + this.currentFilter.fieldId)
        if (defaultInput) defaultInput.value = '';
        if (fieldInput) fieldInput.value = '';
        if (fieldInput2) fieldInput2.value = '';
        this.dropdowndata.isFieldDropDownOpen = false;
        this.dropdowndata.isOperatorDropDownOpen = false;
        this.dropdowndata.isOptionDropDownOpen = false;
        this.dropdowndata.filters = Helpers.deepClone(this.filters);
        if (index >= 0) {
          this.selectedFilters[index] = Helpers.deepClone(this.dropdowndata);
        } else {
          this.currentFilter = Helpers.deepClone(this.dropdowndata);
        }
      }
    });
  }

  doEmpty() {
    this.hierarchyMapping = [];
    this.hierarchyFilterMapping = [];
    this.hierarchies_search = [];
    this.selectedLevel = {
      key: "",
      label: "Select level",
      options: ["ALL"],
      value: "ALL"
    };

  }
  reloadComponent() {
    if (!this.isAccount) {
      this.initHierarchyFilter();
    } else {
      this.isHierarchyFilterEnabled = false
    }

    // this.initGlobalFilters();
  }
  ngOnDestroy() {
  }

  getSavedFilters() {
    let params: any = {};
    if (this.projectId && !Helpers.isAccount) {
      params.brand_id = this.projectId;
    } else if (this.accountId && Helpers.isAccount) {
      params.account_id = this.accountId;
    }
    if (!_.isEmpty(params)) {
      this.globalFilterService.getSavedFilters(params).subscribe((response: any) => {
        if (response.code == 0 && _.hasIn(response, 'data.filters') && !_.isEmpty(response.data.filters)) {
          this.savedFilters = _.get(response, 'data.filters', []);
          this.savedFiltersList = Helpers.deepClone(this.savedFilters);
        }
      }, (err) => {
        console.log("Error: while getting saved filters", err);
      })
    }
  }

  changeTab(tabName: string) {
    this.activeTab = tabName;

    if (tabName == 'by_hierarchy') {
      let global_filter_data = this.globalFilterService.getAppliedFilters();
      if (global_filter_data) {
        if (global_filter_data.by_hierarchy_drilldown && global_filter_data.by_hierarchy_drilldown.length) {
          this.hierarchyMapping = _.merge(Helpers.deepClone(this.hierarchyMapping), Helpers.deepClone(global_filter_data.by_hierarchy_drilldown));
        }
        if (global_filter_data.by_hierarchy_level_and_value && !_.isEmpty(global_filter_data.by_hierarchy_level_and_value)) {
          this.selectedLevel = Helpers.deepClone(global_filter_data.by_hierarchy_level_and_value);
        }
      }
      this.isDisableApplyButton();
    } else if (tabName != 'by_hierarchy') {
      if (tabName == 'saved_filter') {
        this.getSavedFilters()
      } else {
        this.isApplyButtonEnabled = false;
        this.initGlobalFilters();
      }

    }
  }

  /**
   * Manish Kumar
   * @param event
   * @param index 
   * Calling for hierarchy filter by drilldown
   */
  selectChildForDrilldownHierarchy(key: string, label: string, value: string, index: number) {
    this.searchLevelText = '';
    // On event clicking (option selection from html) call API to get child hierarchy level
    const hierarchyIndex = _.findIndex(this.hierarchyMapping, { key: key, label: label });
    const currentHierarchy = Helpers.deepClone(this.hierarchyMapping[hierarchyIndex]);
    this.hierarchyMapping = _.map(this.hierarchyMapping, (object: any, index: number) => {
      if (currentHierarchy.value != value) {
        if (object.key == key && object.label == label) {
          object.value = value;
        }

        if (value != "ALL") {
          if (index < hierarchyIndex + 1) {
            object.enabled = true;
          } else if (index == hierarchyIndex + 1) {
            object.enabled = true;
            object.value = "ALL";
          } else {
            object.enabled = false;
            object.value = "ALL";
          }
        } else {
          if (index <= hierarchyIndex) {
            object.enabled = true;
          } else {
            object.enabled = false;
            object.value = "ALL";
          }
        }
        if (index == 1 && object.value != 'ALL') {
          this.isApplyButtonEnabled = true
        } else if (index == 1 && object.value == 'ALL') {
          this.isApplyButtonEnabled = false
        }

      }
      object.isDropDownOpen = false;
      return object;
    })
    // Enable apply button for Hierarchy drilldown if previous applied and current hierarchy selection is not same
    this.enableApplyButtonIfRequired(hierarchyIndex, value);
    const el = document.getElementById(`level-list-${hierarchyIndex}`) as HTMLElement;
    el.style.display = "none";
  }

  enableApplyButtonIfRequired(hierarchyIndex?, value?) {
    let appliedHierarchy = this.globalFilterService.getAppliedFilters();
    if (appliedHierarchy && appliedHierarchy['by_hierarchy_level_and_value'] && (appliedHierarchy['by_hierarchy_level_and_value'].key != '' || appliedHierarchy['by_hierarchy_level_and_value'].label !== 'Select level')) {
      this.isApplyButtonEnabled = true;
    }
    if (appliedHierarchy && appliedHierarchy['by_hierarchy_drilldown'] && appliedHierarchy['by_hierarchy_drilldown'].length > 1) {
      const appliedHierarchyLength = appliedHierarchy['by_hierarchy_drilldown'].length;
      const selectedHierarchy = this.hierarchyMapping.slice(0, appliedHierarchyLength);
      // Create hash for hierarchy stack
      if (this.hierarchyStackHash(appliedHierarchy['by_hierarchy_drilldown']) == this.hierarchyStackHash(selectedHierarchy)) {
        this.isApplyButtonEnabled = false;
      } else {
        this.isApplyButtonEnabled = true;
      }
    }
  }
  // Create hierarchy hash based on object's key & value
  hierarchyStackHash(arr) {
    if (arr !== undefined) {
      return arr.map(obj => `${obj.key}-${obj.value}`).join('|'); // Simple hash function
    } else {
      return 'NOHASHED'
    }
  }
  getPayloadDetails(obj: any) {
    var details = {
      from: _.get(Helpers, "datePicker.startDate"),
      to: _.get(Helpers, "datePicker.endDate"),
      parent_key: obj.parent_key,
      parent_value: obj.parent_value,
      level: obj.level,
    }
    if(obj.parentIndex > -1 && !this.searchByHierarchyLevelAndValue) {
      details['custom_filter_list'] = this.getCustomFilterList(obj.parentIndex)
    }
    return details;
  }

  // Apply global filter after selection and store in localStorage
  apply(event: any, isInitEvent: boolean) {
    this.isApplyButtonEnabled = false
    if (event) event.stopPropagation();
    if (this.activeTab == 'by_hierarchy') {
      this.applyHierarchFilter(isInitEvent);
    }
    if (this.activeTab == 'by_dimension') {
      this.applyGlobalFilter(isInitEvent);
      this.closeSideBar();
    }
    // this.closeSideBar();
  }

  applyHierarchFilter(isInitEvent) {
    let data: any;
    let hierarchyStack: any;
    let flagToProceed: boolean = true;
    let appliedhierarchy = Helpers.deepClone(_.filter(this.hierarchyMapping, (obj: any) => {
      return obj.enabled == true;
    }));
    if (isInitEvent) {
      appliedhierarchy.splice(1, appliedhierarchy.length);
    }
    if (this.searchByHierarchyLevelAndValue) {
      hierarchyStack = this.globalFilterService.getHierarchyStack([this.defaultAccess, this.selectedLevel]);
      let appliedHierarchy = this.globalFilterService.getAppliedFilters();
      if (appliedHierarchy && appliedHierarchy['by_hierarchy_drilldown'] && appliedHierarchy['by_hierarchy_drilldown'].length > 0) {
        let itemLength = appliedHierarchy['by_hierarchy_drilldown'].length;
        let lastItem = appliedHierarchy['by_hierarchy_drilldown'][itemLength - 1];
        if (lastItem && lastItem.value == 'ALL') {
          lastItem = appliedHierarchy['by_hierarchy_drilldown'][itemLength - 2];
        }
        if (lastItem.key == this.selectedLevel.key && lastItem.label == this.selectedLevel.label && lastItem.value == this.selectedLevel.value) {
          flagToProceed = false;
        }
      }
      data = { 'by_hierarchy_level_and_value': Helpers.deepClone(this.selectedLevel) };
    } else {
      hierarchyStack = this.globalFilterService.getHierarchyStack(appliedhierarchy);
      data = { 'by_hierarchy_drilldown': Helpers.deepClone(appliedhierarchy) };
    }

    if (flagToProceed) {
      this.globalFilterService.setValuesForGlobalUse({ globalFilter: data, type: 'applied_hierarchy_filter' });
      this._helpers.setHierarchyStack(hierarchyStack);
      this.closeSideBar();
    } else {
      this.isApplyButtonEnabled = false;
      Helpers.smallAlertBox("Warning", 'No changes applied.', "warn", 3500);
    }
  }

  applyGlobalFilter(isInitEvent) {
    let defaultInput: any = document.getElementById('option_search_option_dropdown_current_filter');
    if (defaultInput) {
      defaultInput.value = '';
    }
    if (!_.isEmpty(this.currentFilter) && this.currentFilter.values && this.currentFilter.values.length) {
      this.activeFilterId = null;
      const index = _.findIndex(this.selectedFilters, { filterType: this.currentFilter.filterType, fieldId: this.currentFilter.fieldId || this.currentFilter.key });
      this.currentFilter.isOptionDropDownOpen = false;
      if (index < 0) {
        this.selectedFilters.push(this.currentFilter)
      } else {
        this.selectedFilters[index] = this.currentFilter;
      }

      let fieldInput: any = document.getElementById('option_search_' + this.currentFilter.fieldId)
      if (fieldInput) {
        fieldInput.value = '';
      }
    }
    if (!_.isEmpty(this.tempFilter) && this.tempFilter.values && this.tempFilter.values.length) {
      this.activeFilterId = null;
      const index = _.findIndex(this.selectedFilters, { filterType: this.tempFilter.filterType, fieldId: this.tempFilter.fieldId || this.tempFilter.key });
      this.currentFilter.isOptionDropDownOpen = false;
      if (index < 0) {
        this.selectedFilters.push(this.tempFilter)
      } else {
        this.selectedFilters[index] = this.tempFilter;
      }

      let fieldInput: any = document.getElementById('option_search_' + this.tempFilter.fieldId)
      if (fieldInput) {
        fieldInput.value = '';
      }
    }
    this.tempFilter = {}
    this.showCurrentFilter = false;
    this.currentFilter = Helpers.deepClone(this.defaultFilterObject);
    this.appliedGlobalFilter = _.filter(Helpers.deepClone(this.selectedFilters), (object: any) => {
      return (object.values.length);
    });
    this.appliedGlobalFilter = _.map(this.appliedGlobalFilter, (filter: any) => {
      filter.isFieldDropDownOpen = false;
      filter.isOperatorDropDownOpen = false;
      filter.isOptionDropDownOpen = false;
      return filter;
    })
    this.selectedFilters = Helpers.deepClone(this.appliedGlobalFilter);
    const multiSelectFilters = this.globalFilterService.getMultiSelectQuestionFilter(this.appliedGlobalFilter);
    let formatedFilters = this.globalFilterService.getFormatedUniversalFilter(this.appliedGlobalFilter);
    if (multiSelectFilters && !_.isEmpty(multiSelectFilters)) {
      Object.assign(formatedFilters.question_filter, multiSelectFilters);
    }
    formatedFilters = this.globalFilterService.excludeMultiSelectFilter(formatedFilters);
    this.globalFilterService.storeUniversalFilters({ filterId: this.activeFilterId, isAppliedFromAccount: this.isAccount, filters: this.appliedGlobalFilter });
    this._helpers.setUniversalFilters(formatedFilters);
    this.currentFilter = {}
    this.activeFilterId = null;
  }


  // Search & get the hierarchy list
  searchHierarchyValues(item: any) {
    const hierarchyIndex = _.findIndex(this.hierarchyMapping, { key: item.key, label: item.label });
    this.loadDropDownOptions(item);
    // if (hierarchyIndex > 0) {
    //   this.od
    //   let possible_values: any[] = ["ALL"];
    //   const currentHierarchy = (this.searchByHierarchyLevelAndValue) ? this.selectedLevel : this.hierarchyMapping[hierarchyIndex];
    //   const parentHierarchy = (this.searchByHierarchyLevelAndValue) ? this.defaultAccess : this.hierarchyMapping[hierarchyIndex - 1];
    //   let param: any = this.getPayloadDetails({ 'parent_key': parentHierarchy.key, 'parent_value': parentHierarchy.value, 'level': currentHierarchy.key });
    //   param.search_text = this.searchLevelText;
    //   this.getHierarchyData(param, (values: any) => {
    //     if (values.length > 0) {
    //       possible_values = possible_values.concat(values);
    //       if (this.searchByHierarchyLevelAndValue) {
    //         this.selectedLevel.options = possible_values;
    //       } else {
    //         this.hierarchyMapping[hierarchyIndex].options = possible_values;
    //       }
    //       this.searchLevelNotFound = false;

    //     } else {
    //       this.searchLevelNotFound = true;
    //     }
    //   })
    // }
  }


  huddleBrands: any = null;
  brandCreatedDate: any = null;
  huddleHierarchyValues: any = {}
  initHierarchyFilter() {
    // Call service to get logged in manager default access
    this.globalFilterService.getDefaultAccess((parameter: any) => {
      this.manager_type = _.get(parameter, 'manager_type');
      if (parameter && parameter['project_id'] && this.manager_type != 3) {
        this.project_id = parameter['project_id'];
        this.huddleHierarchyValues = {}
        this.getBrandDetails(parameter.project_id, (brandDetail: any) => {
          if (brandDetail && _.has(brandDetail, 'is_single_touchpoint_setup') && brandDetail['is_single_touchpoint_setup'] == true && parameter.access_key != undefined) {
            this.huddleBrands = _.map(_.get(brandDetail, "action_management_configuration.huddle.modules"), (detail) => _.get(detail, 'config.brand_id'));
            this.brandCreatedDate = new Date(_.get(brandDetail, "created_date"));
            this.globalFilterService.setMappedHierarhcyLevels(brandDetail, (data: any) => {
              this.hierarchyMapping = Helpers.deepClone(data.hierarchyMapping);
              this.hierarchies_search = Helpers.deepClone(data.hierarchyMapping);
              this.hierarchyFilterMapping = Helpers.deepClone(data.hierarchyMapping);
              // Initialized loggedIn User Level & Value
              this.loggedInUserLevel = Object.keys(parameter.access_key)[0];
              this.loggedInUserValues = parameter.access_key[this.loggedInUserLevel].values;
              let cohortAccess: any = (parameter && _.hasIn(parameter, 'access_key.' + this.loggedInUserLevel + ".cohort_fields") && !_.isEmpty(parameter.access_key[this.loggedInUserLevel].cohort_fields)) ? parameter.access_key[this.loggedInUserLevel].cohort_fields : {}
              let defaultIndex = 0
              if (!_.isEmpty(cohortAccess)) {
                this.prepareAndApplyCohortAccess(cohortAccess)
              }
              this.hierarchyMapping = _.map(this.hierarchyMapping, (object: any, index: number) => {
                if (object.key == this.loggedInUserLevel) {
                  object.options = this.loggedInUserValues;
                  object.value = this.loggedInUserValues[0];
                  object.enabled = true;
                  defaultIndex = index;
                  this.defaultAccess = object;
                }
                object.isDropDownOpen = false;
                return object;
              })
              if (defaultIndex >= 0 && this.hierarchyMapping.length > 1) {
                if (this.hierarchyMapping[defaultIndex + 1]) {
                  this.hierarchyMapping[defaultIndex + 1].enabled = true;
                  this.hierarchies_search.splice(0, defaultIndex + 1);
                }
                this.hierarchyMapping.splice(0, defaultIndex);
                this.apply(null, true);
              }
              if (this.hierarchyMapping.length == 1) {
                this.apply(null, true);
              }
            })
          } else {
            this.setDefaultTouchpointLevel()
          }
        })
      } else {
        this.setDefaultTouchpointLevel()
      }
    });
  }

  // this is temprory in future if its not required we can remove this code becuase same code is written in app state service
  prepareAndApplyCohortAccess(cohortAccess) {
    let filterMapping = this.globalFilterService.getGolbalFilters();
    let universalFilter = this.globalFilterService.getUniveralFilters();
    let appliedFilters: any = []
    if (_.isEmpty(universalFilter)) {
      universalFilter = {
        isAppliedFromAccount: false,
        filters: []
      }
    }
    const tagFilter = filterMapping['transaction_filter'];
    let filters: any = []
    if (tagFilter && tagFilter.filters && tagFilter.filters.length) {
      _.each(cohortAccess, (data: any, key: string) => {
        const filter: any = _.find(tagFilter.filters, { field_id: key })
        if (data && data.length && filter && !_.isEmpty(filter)) {
          let details: any = [];
          _.each(data, (value: any) => {
            if (value) {
              details.push({
                "text": value,
                "value": value
              })
            }
          })
          filters.push(
            {
              "filterType": "transaction_filter",
              "fieldId": filter?.field_id || key,
              "fieldText": filter?.name || filter?.text,
              "operator": "eq",
              "isMultiSelect": false,
              "isAccessLevelFilter": true,
              "operatorText": "Equal To",
              "valueText": data.join(","),
              "values": data,
              "labels": data,
              "details": details,
              "possibleValues": data,
              "filterText": "Metadeta",
            }
          )
        }

      })
    }
    // If user have colort access given
    if(!filterMapping['transaction_filter'] && (!_.isEmpty(cohortAccess))) {

      filterMapping['transaction_filter'] = {
        label: "Metadata",
        filterType: "transaction_filter",
        sequence: 4,
        operators: this.globalFilterService.transactionOperator,
        filters: []
      };
      _.each(cohortAccess, (data: any, key: string) => {
        let details: any = [];
        _.each(data, (value: any) => {
          if (value) {
            details.push({
              "text": value,
              "value": value
            })
          }
        })
        // Prepare to set into global filter
        filterMapping['transaction_filter'].filters.push(
          {
          "field_id": key,
          "name": key.replace('tag_',''),
          "download": true,
          "show_in_inbox_detail": true,
          "is_single_request_initiation": false,
          "action_filter": true,
          "es_filter": true,
          "compare_filter": true,
          "data_type": "string",
          "possible_value_search": true,
          "search": true,
          "text": key.replace('tag_',''),
          "add_in_filter_list": true,
          "options": [],
          "isSearchEnabled": true
        })
        // Prepare to set universal filter
        var obj = {
          "filterType": "transaction_filter",
          "fieldId": key,
          "appliedFrom": "hierarchy_widget",
          "operator": "eq",
          "operatorText": "Equal To",
          "values": cohortAccess[key],
          "labels": cohortAccess[key],
          "details": details,
          "possibleValues": data,
          "valueText": cohortAccess[key].join(","),
          "fieldText": key.replace('tag_',''),
          "filterText": "Metadata",
          "isAccessLevelFilter": true
        }
        filters.push(obj);
      })
      this.globalFilterService.setGlobalFilter(filterMapping);
    }
    if (filters && filters.length) {
      universalFilter.filters = filters;
      const formatedFilters = this.globalFilterService.getFormatedUniversalFilter(universalFilter.filters);
      this.globalFilterService.storeUniversalFilters(universalFilter);
      this._helpers.setUniversalFilters(formatedFilters);
    }
  }

  // Need to implement hierarhcy fallback for manager_type:3 or static project
  setDefaultTouchpointLevel() {
    // this.mappedHierarchyLevelNames["touchpoints"] = "Touchpoints";
    this.loggedInUserLevel = "touchpoints"
    this.loggedInUserValues = ["All Touchpoints"]
  }
  searchByHierarchyFilter(event: any, flag: boolean) {
    event.preventDefault();
    this.searchLevelNotFound = false;
    this.searchByHierarchyLevelAndValue = flag;
    this.isDisableApplyButton();
  }
  isDisableApplyButton() {
    this.isApplyButtonEnabled = false;
    let global_filter_data = this.globalFilterService.getAppliedFilters();

    if (this.searchByHierarchyLevelAndValue) {
      if (global_filter_data && global_filter_data.by_hierarchy_level_and_value && !_.isEmpty(global_filter_data.by_hierarchy_level_and_value)) {
        this.selectedLevel = Helpers.deepClone(global_filter_data.by_hierarchy_level_and_value);
      } else {
        this.resetData()
      }
    } else {
      if (global_filter_data.by_hierarchy_drilldown && global_filter_data.by_hierarchy_drilldown.length) {
        this.hierarchyMapping = Helpers.deepClone(this.hierarchyFilterMapping);
        this.hierarchies_search = Helpers.deepClone(this.hierarchyFilterMapping);
        const defaultAccess = global_filter_data.by_hierarchy_drilldown[0];
        const index = _.findIndex(Helpers.deepClone(this.hierarchyFilterMapping), { key: defaultAccess.key });
        this.hierarchyMapping.splice(0, index);
        let nextFilter: number = 0;
        this.hierarchies_search.splice(0, index + 1);
        this.hierarchyMapping = _.map(this.hierarchyMapping, (object: any, ind: any) => {
          if (global_filter_data.by_hierarchy_drilldown[ind] && object.key == global_filter_data.by_hierarchy_drilldown[ind].key) {
            object.options = global_filter_data.by_hierarchy_drilldown[ind].options
            object.value = global_filter_data.by_hierarchy_drilldown[ind].value
            object.enabled = true
            nextFilter = ind + 1;
          }
          if (ind == 1) {
            object.enabled = true
          }
          return object;
        })
        this.defaultAccess = defaultAccess;
      } else {
        this.resetData()
      }
      // Enable apply button for Hierarchy drilldown if Search by Levels and Values hierarchy already applied.
      this.enableApplyButtonIfRequired();
    }
  }


  getBrandDetails(project_id: string, cb: any) {
    const brandDetails = _.get(Helpers, 'brandDetails', {})
    if (brandDetails && brandDetails['_id'] && brandDetails['_id'] == project_id) {
      // console.log("No need to call API")
      cb(brandDetails)
    } else {
      this.accountsService.getBrandDetail(project_id).subscribe((result: any) => {
        if (result && result.code == 0) {
          if (result.data && result.data.brand) {
            cb(result.data.brand);
          }
        } else {
          cb({})
        }
      });
    }
  }




  // Retieving fro localStorage if global filter already applied
  getAppliedHierarchyFilter() {
    let appliedHierarchyFilter = {};
    this.globalFilterService.globalFilterState$.subscribe(state => {
      if (state && state.globalFilter) {
        appliedHierarchyFilter = state.globalFilter;
      }
    })
    return appliedHierarchyFilter;
  }
  // Clear input search text
  isSelectionClicked() {
    this.searchLevelText = '';
  }
  // Open & Close dynamic filter sidebar
  openSideBar(event: any, data?: any) {
    this.resetData();
    this.searchLevelText = '';

    this.isApplyButtonEnabled = false;
    if (!this.isAccount) {
      this.isHierarchyFilterEnabled = (data && _.hasIn(data, 'isHierarchyFilterEnabled')) ? _.get(data, 'isHierarchyFilterEnabled') : true;
    } else {
      this.isHierarchyFilterEnabled = false;
    }


    this.isUniversalFilterEnabled = (data && _.hasIn(data, 'isUniversalFilterEnabled')) ? _.get(data, 'isUniversalFilterEnabled') : true;
    this.isHuddleFilterEnabled = (data && _.hasIn(data, 'isHuddleFilterEnabled')) ? _.get(data, 'isHuddleFilterEnabled') : false;
    let global_filter_data = this.globalFilterService.getAppliedFilters();

    if (this.isUniversalFilterEnabled) {
      // this.getSavedFilters();
    }
    if (global_filter_data) {
      if (global_filter_data.by_hierarchy_drilldown && global_filter_data.by_hierarchy_drilldown.length) {
        this.searchByHierarchyLevelAndValue = false;
        this.hierarchyMapping = Helpers.deepClone(this.hierarchyFilterMapping);
        this.hierarchies_search = Helpers.deepClone(this.hierarchyFilterMapping);
        const defaultAccess = global_filter_data.by_hierarchy_drilldown[0];
        const index = _.findIndex(Helpers.deepClone(this.hierarchyFilterMapping), { key: defaultAccess.key });
        this.hierarchyMapping.splice(0, index);
        let nextFilter: number = 0;
        this.hierarchies_search.splice(0, index + 1);
        this.hierarchyMapping = _.map(this.hierarchyMapping, (object: any, ind: any) => {
          if (global_filter_data.by_hierarchy_drilldown[ind] && object.key == global_filter_data.by_hierarchy_drilldown[ind].key) {
            object.options = global_filter_data.by_hierarchy_drilldown[ind].options
            object.value = global_filter_data.by_hierarchy_drilldown[ind].value
            object.enabled = true
            nextFilter = ind + 1;
          }
          // For initial hierarchy load, if 2nd position object have enabled is false then make it 'enabled: true' to list in hierarchy dropdown for selection
          if (ind == 1) {
            object.enabled = true
          }
          return object;
        })
        this.defaultAccess = defaultAccess;

        // this.hierarchyMapping = _.merge(Helpers.deepClone(this.hierarchyMapping), Helpers.deepClone(global_filter_data.by_hierarchy_drilldown));
      }
      if (global_filter_data.by_hierarchy_level_and_value && !_.isEmpty(global_filter_data.by_hierarchy_level_and_value)) {
        this.searchByHierarchyLevelAndValue = true;
        this.selectedLevel = Helpers.deepClone(global_filter_data.by_hierarchy_level_and_value);
      }
    }
    if (this.isUniversalFilterEnabled) {
      this.initGlobalFilters();
    }
    if (this.isHuddleFilterEnabled) {
      this.initHuddleFilter();
    }
    if (data) {
      if (data.tabName && data.tabName != "") {
        this.activeTab = data.tabName;
      }
      if (data.filterType && (data.filterType != "hierarchy" || data.filterType != "")) {
        this.highlightType = data.filterType;
      }
      if (data.filterType && data.filterType == "universal_filter" && this.isActiveActionTab) {
        this.activeTab = 'saved_filter'
        this.getSavedFilters();
      }
    }
    if ((data.filterType == "hierarchy" && this.isHierarchyFilterEnabled) || (data.filterType != "hierarchy" && this.isUniversalFilterEnabled) || (data.filterType != "hierarchy" && this.isHuddleFilterEnabled)) {
      this.showOverlay = true
      setTimeout(() => {
        this.isSidebarOpen = true;
      }, 300);

    }

    setTimeout(() => {
      this.highlightType = "";
    }, 1500);
    if (this.activeTab == 'saved_filter') {

    }
  }

  clearHighlight() {
    this.highlightType = "";
  }

  resetData() {

    this.hierarchyMapping = _.map(this.hierarchyMapping, (obj: any, index: number) => {
      if (index <= 1) {
        obj.enabled = true;
      } else {
        obj.enabled = false;
      }
      if (index != 0) {
        obj.value = "ALL";
      }
      return obj;
    })
    this.selectedLevel = {
      key: "",
      label: "Select level",
      options: ["ALL"],
      value: "ALL"
    }
  }

closeSideBar(event?: any) {
  this.searchByHierarchyLevelAndValue = false;

  // Clear search input related to "by_dimension"
  this.searchText = '';                     
  this.filterName = '';                     
  this.currentFilter = {};                
  this.showCurrentFilter = false;            

  if (event) event.stopPropagation();
  this.ngOnDestroy();
  this.isSidebarOpen = false;
  setTimeout(() => {
    this.showOverlay = false;
  }, 300);
}
  // Searchable dropdown
  showHideHierarchySearchContainer(event: any, boolean: boolean, item: any, index: number) {
    this.hierarchyDrillDownDivId = 'level-list-' + index;
    this.childHierarchyIndex = index;
    this.isSelectionClicked()
    // event.preventDefault();
    event.stopPropagation();
    if (this.searchByHierarchyLevelAndValue || (!this.searchByHierarchyLevelAndValue && index > 0)) {
      let loadDropDownData = false;
      this.hierarchyMapping = _.map(this.hierarchyMapping, (object: any) => {
        if (object.key == item.key && !item.isDropDownOpen) {
          object.isDropDownOpen = true;
          loadDropDownData = true;
        } else {
          object.isDropDownOpen = false;
        }
        return object;
      })
      if (loadDropDownData) {
        this.loadDropDownOptions(item);
      }

    }
  }

  showHideHierarchySearchDropDown(key: string, divId?, event?) {
    if (event) event.stopPropagation();
    this.searchLevelNotFound = false;
    this.hierarchyLevelAndValueDivId = divId;
    this.isSelectionClicked()
    if (this.searchByHierarchyLevelAndValue) {
      let levelEl = document.getElementById('level-list-hierarchy-levels') as HTMLElement;
      let valueEl = document.getElementById('level-list-hierarchy-values') as HTMLElement;
      let ddIconLevels = document.getElementById('dropdown-icon--levels') as HTMLElement;
      let ddIconValues = document.getElementById('dropdown-icon-values') as HTMLElement;


      if (ddIconLevels) {
        ddIconLevels.classList.remove('active')
      }
      if (ddIconValues) {
        ddIconValues.classList.remove('active')
      }
      if (levelEl) {
        levelEl.style.display = 'none';
      }
      if (valueEl) {
        valueEl.style.display = 'none';
      }


      if (key == 'hierarchy-levels') {
        if (this.hierarchyLevelAndValue.selectLevel) {
          this.hierarchyLevelAndValue.selectLevel = false;
        } else {
          this.hierarchyLevelAndValue.selectLevel = true;
        }
      }

      if (key == 'hierarchy-values') {
        if (this.hierarchyLevelAndValue.selectValue) {
          this.hierarchyLevelAndValue.selectValue = false;
        } else {
          this.hierarchyLevelAndValue.selectValue = true;
          if (this.selectedLevel && this.selectedLevel.key && this.selectedLevel.key != "") {
            this.loadDropDownOptions(this.selectedLevel);
          }
        }

      }
    }
  }

  selectHierarchyLevel(level: any, value?: string) {
    this.selectedLevel = level;
    if (value) {
      this.selectedLevel.value = value;
    }
    if (this.selectedLevel.value == 'ALL') {
      this.isApplyButtonEnabled = false;
    } else {
      this.isApplyButtonEnabled = true;
      // Check if already applied levels & value
      let appliedHierarchy = this.globalFilterService.getAppliedFilters();
      if (appliedHierarchy && appliedHierarchy['by_hierarchy_level_and_value'] && (appliedHierarchy['by_hierarchy_level_and_value'].key != '' || appliedHierarchy['by_hierarchy_level_and_value'].label !== 'Select level')) {
        if (this.selectedLevel && (this.selectedLevel.key == appliedHierarchy['by_hierarchy_level_and_value'].key) && (this.selectedLevel.label == appliedHierarchy['by_hierarchy_level_and_value'].label) && (this.selectedLevel.value === appliedHierarchy['by_hierarchy_level_and_value'].value)) {
          this.isApplyButtonEnabled = false;
        }
      }
    }
    this.hierarchyLevelAndValue.selectLevel = false;
    this.hierarchyLevelAndValue.selectValue = false;
    this.showHideHierarchySearchDropDown("none");
  }

  loadDropDownOptions(data: any) {
    const index = _.findIndex(this.hierarchyMapping, { key: data.key, label: data.label });
    if (index > 0) {
      if (!this.isHuddleTabActive) {
        let possible_values: any[] = ["ALL"];
        const currentHierarchy = (this.searchByHierarchyLevelAndValue) ? this.selectedLevel : this.hierarchyMapping[index];
        const parentHierarchy = (this.searchByHierarchyLevelAndValue) ? this.defaultAccess : this.hierarchyMapping[index - 1];
        var param: any = this.getPayloadDetails({ 'parent_key': parentHierarchy.key, 'parent_value': parentHierarchy.value, 'level': currentHierarchy.key, 'parentIndex': index - 1 });
        if (this.searchLevelText && this.searchLevelText != '')
          param.search_text = this.searchLevelText.trim();

        this.getHierarchyData(param, (values: any) => {
          if (values.length > 0) {
            possible_values = possible_values.concat(values);
            if (this.searchByHierarchyLevelAndValue) {
              this.selectedLevel.options = possible_values;
            }
            this.hierarchyMapping[index].options = possible_values;
            this.searchLevelNotFound = false;
          } else {
            this.searchLevelNotFound = true;
          }

        })
      } else {
        let possible_values: any[] = ["ALL"];
        let level = this.hierarchyMapping[index].key

        if (this.searchLevelText) {
          let search_text = this.searchLevelText.trim();
          let values: any = Helpers.deepClone(this.huddleHierarchyValues[level])
          if (this.searchLevelText != '') {
            values = _.filter(Helpers.deepClone(this.huddleHierarchyValues[level]), (value: string) => {
              return (value.toLocaleLowerCase().indexOf(search_text.toLocaleLowerCase()) >= 0) ? true : false
            })
          }
          if (values.length > 0) {
            possible_values = possible_values.concat(values);
            if (this.searchByHierarchyLevelAndValue) {
              this.selectedLevel.options = possible_values;
            }
            this.hierarchyMapping[index].options = possible_values;
            this.searchLevelNotFound = false;
          } else {
            this.searchLevelNotFound = true;
          }
        } else {
          const params: any = this.getParameterForHuddle(index);
          this._feedService.getFeedAndUserfilter(params).subscribe((response: any) => {
            if (_.get(response, 'data.code') == 0 && _.has(response, 'data.feed') && !_.isEmpty(response.data.feed)) {
              var keytoFetch: any = null;
              if (this.hierarchyMapping[index].key) {
                keytoFetch = "tag_private_group_" + this.hierarchyMapping[index].key;
              }
              var values = _.uniq(_.map(response.data.feed, (data) => {
                return _.get(data, "feedback_request_data." + keytoFetch + ".0");
              }));
              if (values.length > 0) {
                possible_values = possible_values.concat(values);
                if (this.searchByHierarchyLevelAndValue) {
                  this.selectedLevel.options = possible_values;
                }
                this.huddleHierarchyValues[level] = Helpers.deepClone(possible_values)
                this.hierarchyMapping[index].options = possible_values;
                this.searchLevelNotFound = false;
              } else {
                this.huddleHierarchyValues[level] = Helpers.deepClone(possible_values)
                this.searchLevelNotFound = true;
              }
            }
          })

        }
      }

    }

  }

  getParameterForHuddle(index: number) {
    let currentHierarchyLevel = this.hierarchyMapping[index - 1].key;
    let nextLevelToAggr: any = null;
    if (index <= (this.hierarchyMapping.length - 2)) {
      nextLevelToAggr = this.hierarchyMapping[index].key
    }
    var paramters: any = {
      brand_id_list: this.huddleBrands,
      from: moment(this.brandCreatedDate).format('YYYYMMDD'), // brandCreatedDate,
      to: moment().format('YYYYMMDD'),
      limit: 1000,
      page_number: 1,
      search_type: "tag_private_group_" + currentHierarchyLevel, //(currentHierarchyLevel) ? ("tag_private_group_" + currentHierarchyLevel) : null, // "tag_private_group_h_0_0",
      // search_text: "Overall", // currentHierarchyValue, //"Overall", //(params.term) ? params.term.trim() : params.term,
      feed_source_include: ["litmus_processed_data.tag_meeting_id"],
      custom_filter_list: this.getCustomFilterList(index),
      is_search_by_custom_filter: true
    }
    if (nextLevelToAggr) {
      paramters.field_to_agg_on = "tag_private_group_" + nextLevelToAggr;
      var fieldToInclude = "litmus_processed_data.tag_private_group_" + nextLevelToAggr;
      paramters.feed_source_include.push(fieldToInclude);
    }
    return paramters;

  }

  getCustomFilterList(index: number) {
    var customFilterList: any = [];
    if (this.hierarchyMapping && !_.isEmpty(this.hierarchyMapping)) {
      _.each(this.hierarchyMapping, (hierarchy: any, idx: number) => {
        if (hierarchy.value != "All" && hierarchy.value != "ALL" && idx < index) {
          customFilterList.push({
            "field": hierarchy.key,
            "value": hierarchy.value
          })
        }
      })
    } else if (this.defaultAccess.key && this.defaultAccess.value) {
      customFilterList.push({
        "field": this.defaultAccess.key,
        "value": this.defaultAccess.value
      })
    }
    // Remove duplicates based on field
    customFilterList = _.uniq(customFilterList, "field");
    return customFilterList;
  }

  getHierarchyData(param: any, cb: any) {
    this.hierarchyService.getHierarchyCustomSearchLevels(this.project_id, param).subscribe(
      (response) => {
        cb(response.data.possible_values);
      },
      (error) => {
        console.error('Error GetCustom details API call:', error);
        cb([]);
      }
    );
  }

  resetToCurentAcccess(event?: any) {
    event?.stopPropagation();
    this.selectedLevel = {
      key: "",
      label: "Select level",
      options: ["ALL"],
      value: "ALL"
    };

    this.hierarchyMapping = _.map(Helpers.deepClone(this.hierarchyMapping), (hierarchy: any, index: number) => {
      if (index > 0) {
        hierarchy.value = "ALL";
        hierarchy.enabled = false;
        if (index == 1) {
          hierarchy.enabled = true;
        }
      }
      return hierarchy;
    })
    this.hierarchies_search = _.map(Helpers.deepClone(this.hierarchies_search), (hierarchy: any, index: number) => {
      hierarchy.value = "ALL";
      hierarchy.enabled = false;
      return hierarchy;
    })
    this.applyHierarchFilter(false);
    this.closeSideBar();
  }


  initGlobalFilters() {
    this.selectedFilters = [];
    const filterMap = this.globalFilterService.getGolbalFilters();
    this.filters = Object.values(filterMap);
    let univeralFilters = this.globalFilterService.getUniveralFilters();
    this.activeFilterId = (univeralFilters && univeralFilters.filterId) ? univeralFilters.filterId : null;
    this.savedFiltersList = _.map(this.savedFiltersList, (filter: any) => {
      if (univeralFilters && filter._id == univeralFilters.filterId) {
        filter.isActive = true;
      } else {
        filter.isActive = false;
      }
      return filter;
    })
    if (univeralFilters && univeralFilters.filters && univeralFilters.filters.length) {
      const appliedFilters = _.map(Helpers.deepClone(univeralFilters.filters), (filter: any) => {
        if (filter?.isQuestionAsTagFilter || filter?.is_question_as_tag || filter?.fieldDefinitionType == "response" || filter?.fieldDefinitionType == "interaction") {
          filter.isSearchEnabled = false;
        }
        return filter;
      });
      this.appliedGlobalFilter = appliedFilters;
      this.selectedFilters = Helpers.deepClone(appliedFilters);
      this.filterStore = Helpers.deepClone(appliedFilters)
      this.updateFilterLists();
      this.showCurrentFilter = false;
    } else {
      this.appliedGlobalFilter = [];
      this.selectedFilters = [];
      this.filterStore = []
      this.currentFilter = Helpers.deepClone(this.defaultFilterObject);
      this.currentFilter.filters = Object.values(filterMap);
      this.showCurrentFilter = true;
    }

  }

  toggleFieldDropDown(event: any, fieldId: string, object: any) {
    event.stopPropagation();


    object.isOperatorDropDownOpen = false;
    object.isOptionDropDownOpen = false;
    if (!object.isFieldDropDownOpen) {
      object.isFieldDropDownOpen = true;
    } else {
      // object.isFieldDropDownOpen = false
    }

    this.dropdownId = "field_dropdown_" + fieldId;
    this.dropdowndata = Helpers.deepClone(object);
    if (!object.isFieldDropDownOpen) {
      // setTimeout(() => {
      const searchInput: any = document.getElementById('field_search_' + fieldId);
      if (searchInput) {
        searchInput.value = '';
        searchInput.focus();
      }
      // }, 100);
    }

  }
  toggleOpratorDropdown(event: any, elementId: string, object: any) {
    event.stopPropagation();


    object.isFieldDropDownOpen = false;
    object.isOptionDropDownOpen = false;
    if (!object.isOperatorDropDownOpen) {
      object.isOperatorDropDownOpen = true;
    } else {
      object.isOperatorDropDownOpen = false;
    }
    this.dropdownId = elementId;
    this.dropdowndata = Helpers.deepClone(object);
  }

  toggleOptionDropdown(event: any, elementId: string, object: any, index?: any) {
    event.stopPropagation();


    // object.isFieldDropDownOpen = false;
  object.isOperatorDropDownOpen = false;
    if (!object.isOptionDropDownOpen) {
      object.isOptionDropDownOpen = true;
      this.tempFilter = object;
      // Reset isAllSelected unless all options are already selected
      if (object.values.length !== object.possibleValues.length - 1) { // -1 if "all" is an option
        object.isAllSelected = false;
      }
    } else {
      // object.isOptionDropDownOpen = false;
    }
    this.dropdownId = elementId;
    this.dataIndex = index
    this.dropdowndata = Helpers.deepClone(object);
    this.tempFilter = Helpers.deepClone(object);
    if (object.filterType == 'transaction_filter' && object.details.length > 0) {
      object.possibleValues = Helpers.deepClone(object.details);
    }
    // setTimeout(() => {
    const input: any = document.getElementById('option_search_' + elementId);
    if (input) {
      // input.value = ''
      input.focus()
    }
    // }, 100);
  }

  filterField(event: any, object: any, index?: number) {  
    event.stopPropagation();
    let searchText = _.get(event, 'target.value');
    searchText = searchText.toLowerCase();
    let filterObject = Helpers.deepClone(this.currentFilter);
    const defaultObject = Helpers.deepClone(this.defaultFilterObject);
    if (index == undefined || index < 0) {
      index = _.findIndex(this.selectedFilters, { filterType: object.filterType, fieldId: object.fieldId });
    }

    if (index && index >= 0) {
      filterObject = Helpers.deepClone(this.selectedFilters[index]);
    }

    if (searchText != "") {
      filterObject.filters = _.filter(Helpers.deepClone(this.filters), (category: any) => {
        if (category.filters && category.filters.length) {
          category.filters = _.filter(category.filters, (filter: any) => {
            return ((filter.text && filter.text.toLowerCase().indexOf(searchText) >= 0) || (filter.name && filter.name.toLowerCase().indexOf(searchText) >= 0));
          })
        }
        return (category.filters.length > 0);
      })
      if (index && index >= 0) {
        this.selectedFilters[index] = Helpers.deepClone(filterObject);
      } else {
        this.currentFilter = Helpers.deepClone(filterObject);
      }
    } else {
      if (index && index >= 0) {
        this.selectedFilters[index].filters = Helpers.deepClone(this.filters);
      } else {
        this.currentFilter.filters = Helpers.deepClone(this.filters);
      }
    }
  }

  indexToUpdate: number = -1;
  onFieldSelect(event: any, object: any, category: any, field: any, index?: number) {
    event.stopPropagation();
    let filter = Helpers.deepClone(this.currentFilter);
    this.isApplyButtonEnabled = false;
    const defaultObject = Helpers.deepClone(this.defaultFilterObject);
    if (index == undefined || index < 0) {
      index = _.findIndex(this.selectedFilters, { filterType: object.filterType, fieldId: field.field_id || field.key });
    }

    if (index != undefined && index >= 0) {
      this.indexToUpdate = index
      filter = Helpers.deepClone(this.selectedFilters[index]);
    }
    if (filter) {
      filter.filterType = category.filterType;
      filter.isMultiSelect = (category.filterType == "question_filter") ? true : false;
      filter.filterText = category.label;
      filter.fieldId = field.field_id || field.key;
      filter.fieldText = field.text || field.name;
      filter.mainRaterType = field?.main_rater_type || 'NA';
      filter.componentType = field?.component_type || 'NA';
      filter.fieldDefinitionType = field.field_type;
      filter.isQuestionAsTagFilter = (category.filterType == "transaction_filter" && (field.isQuestionAsTagFilter || field.field_type == "response" || field.field_type == "interaction"));
      if (field.field_id_list && field.field_id_list.length) {
        filter.fieldIdList = field.field_id_list
      }

      filter.values = defaultObject.values;
      filter.valueText = defaultObject.valueText;
      filter.operator = defaultObject.operator;
      filter.fieldType = field.type
      filter.operatorText = defaultObject.operatorText;
      filter.filters = Helpers.deepClone(this.filters)
      filter.isSearchEnabled = filter.isQuestionAsTagFilter ? false : !!field.isSearchEnabled;
      filter.operators = (category.operators) ? category.operators : [];
      if (field.type == "multi-select" || field.type == "single-select") {
        filter.operators = _.filter(filter.operators, (op: any) => {
          return (op.value == 'eq' || op.value == 'ne')
        })
      }
      filter.possibleValues = []
      if (category.filterType == "action_filter") {
        filter.idToPrepend = field.id;
      }

      if (field.options && field.options.length) {
        filter.possibleValues = _.map(field.options, (option: any) => {
          option.text = option.label;
          return option;
        })
      } else if (field.possibleValues && field.possibleValues.length) {
        filter.possibleValues = Helpers.deepClone(field.possibleValues);
      }
      // Check if the question is of a specific component type and if extended rater type is 4
      if (field.field_id == "primary_rating" && field?.component_type == 'ltms-nps-five-star-rater' && Helpers.brandDetails?.extended_rater_type === 4 && (!_.isEmpty(Helpers.brandDetails.extended_rating_mapper))) {
        // Get new operator items
        filter.operators = _.filter(filter.operators, (op: any) => {
          return (op.value == 'eq' || op.value == 'ne')
        })
        let options: any = [];
        let originalOptions: any = filter.possibleValues;
        filter.originalPossibleValues = originalOptions;
        for(let i in originalOptions) {
          options.push(this.extenderRatingMapper.getNewOptionsForExtendedRaterType(originalOptions[i], field?.main_rater_type));
          filter.possibleValues = _.sortBy(this.extenderRatingMapper.removeDuplicateOptionsOfExtendedRater(options), 'value').reverse();
        }
      }
      if (field.operators && field.operators.length) {
        filter.operators = Helpers.deepClone(field.operators);
      }
      filter.isFieldDropDownOpen = false
      if (index != undefined && index >= 0) {
        this.selectedFilters[index] = Helpers.deepClone(filter);
      } else {
        this.currentFilter = Helpers.deepClone(filter);
      }
      object.isFieldDropDownOpen = false;
    }
    this.dropdowndata = Helpers.deepClone(filter);
    this.dropdownId = "";
  }

  onOperatorSelect(event: any, object: any, field: any, index?: number) {
    event.stopPropagation();
    const defaultFilterObject = Helpers.deepClone(this.defaultFilterObject);
    let filter = Helpers.deepClone(this.currentFilter);
    if (index == undefined || index < 0) {
      index = _.findIndex(this.selectedFilters, { filterType: object.filterType, fieldId: object.fieldId });
    }
    if (index != undefined && index >= 0) {
      filter = Helpers.deepClone(this.selectedFilters[index]);
    }
    filter.isMultiSelect = (field.value == 'eq' || field.value == 'ne') ? true : false;
    filter.operator = field.value;
    filter.operatorText = field.text;
    filter.values = defaultFilterObject.values;
    filter.valueText = defaultFilterObject.valueText;
    filter.labels = defaultFilterObject.labels;
    filter.details = []
    if (filter.filterType == "text_filter" || filter.operator == 'eq_wildcard') {
      filter.valueText = '';
      filter.isAddButtonDisabled = true;
    }
    if (object.fieldId == "category") {
      filter.details.push(field)
      if (field.children && field.children.length) {
        filter.possibleValues = _.get(field, 'children', []);
      } else {
        filter.operator = defaultFilterObject.operator;
        filter.operatorText = defaultFilterObject.operatorText;
        filter.values = [field.value];
        filter.valueText = field.text;
      }
    }
    filter.isOperatorDropDownOpen = false;
    if (index != undefined && index >= 0) {
      this.selectedFilters[index] = filter;
    } else {
      this.currentFilter = filter;
    }
    this.dropdowndata = Helpers.deepClone(filter);
    object.isOperatorDropDownOpen = false;
    this.dropdownId = "";
  }

  onValueChange(event: any, object: any, field: any, isMultiSelect: boolean, index?: number) {

    event.stopPropagation();
    // this.tempFilter = this.currentFilter;
    const defaultFilterObject = Helpers.deepClone(this.defaultFilterObject);
    if (index == undefined || index < 0) {
      index = _.findIndex(this.selectedFilters, { filterType: object.filterType, fieldId: object.fieldId });
    }
    if (index != undefined && index >= 0) {
      this.tempFilter = this.selectedFilters[index];
    }

    const value = ('value' in field) ? field.value : field;
    const text = ('text' in field) ? field.text : field;

    if (isMultiSelect) {
      const indx = this.tempFilter.values.indexOf(value);

      if (value === 'all') {
        this.tempFilter.values = [];
        this.tempFilter.labels = [];
        this.tempFilter.details = [];

        if (this.tempFilter.isAllSelected) {
          this.tempFilter.isAllSelected = false;
        } else {
          this.tempFilter.isAllSelected = true;
          _.each(this.tempFilter.possibleValues, (option: any) => {
            if (option.value !== 'all') {
              this.tempFilter.values.push(option.value);
              this.tempFilter.labels.push(option.text);
              this.tempFilter.details.push(option);
            }
          })
        }
      } else if (indx >= 0) {
        this.tempFilter.isAllSelected = false;
        this.tempFilter.values = _.filter(this.tempFilter.values, (val: any) => val !== value);
        this.tempFilter.labels = _.filter(this.tempFilter.labels, (val: any) => val !== text);
        this.tempFilter.details = _.filter(this.tempFilter.details, (details: any) => details.value !== value);
      } else {
        this.tempFilter.isAllSelected = false;
        this.tempFilter.values.push(value);
        this.tempFilter.labels.push(text);
        this.tempFilter.details.push(field);
      }
      if (this.tempFilter.isSearchEnabled) {
        // this.tempFilter.possibleValues = _.values(_.union(this.tempFilter.possibleValues, this.tempFilter.details), false, _.property('value'));
        this.tempFilter.possibleValues = _.values(_.merge(_.keyBy(object.possibleValues, 'value'), _.keyBy(this.tempFilter.details, 'value')));
      }
      if (this.tempFilter.values.length) {
        this.tempFilter.valueText = this.tempFilter.labels.join(", ");
      } else {
        this.tempFilter.valueText = defaultFilterObject.valueText;
      }
      // Check if the question is of a specific component type and if extended rater type is 4
      if (this.tempFilter?.fieldId == "primary_rating" && this.tempFilter?.componentType == 'ltms-nps-five-star-rater' && Helpers.brandDetails?.extended_rater_type === 4 && (!_.isEmpty(Helpers.brandDetails.extended_rating_mapper))) {
        // Step 1: Get the dynamic mapping for the current rater type
        const newExtendedRaterMapping: Record<string, number> = this.extenderRatingMapper.getDynamicExtendedRaterMapping(this.tempFilter.mainRaterType);
        const selectedValues = this.tempFilter.values;
        const mappedValues: number[] = [];

        // Step 2: Reverse-map selected values to their original keys
        selectedValues.forEach(selected => {
          for (const [key, value] of Object.entries(newExtendedRaterMapping)) {
            if (value === selected) {
              mappedValues.push(Number(key));
            }
          }
        });
        // Step 3: Get the values & text representation of the mapped values
        const obj = this.extenderRatingMapper.getExtendedRaterTextValues(mappedValues, this.tempFilter);
        this.tempFilter.mappedLabels = obj?.mappedNewLabels;
        this.tempFilter.mappedValues = obj?.mappedNewValues;
        this.tempFilter.mappedValueText = obj?.mappedNewValueText;
      }
      this.toggleApplyButton(this.tempFilter)
    } else {
      if (object.fieldId == 'category') {
        this.tempFilter.details.push(field);
      } else {
        this.tempFilter.details = [field];
      }
      this.tempFilter.values = [value];
      this.tempFilter.valueText = text;
      this.tempFilter.isOptionDropDownOpen = false;
      this.toggleApplyButton(this.tempFilter);
    }

    if (!isMultiSelect) {
      this.activeFilterId = null;
      if (index !== undefined && index >= 0) {
        this.selectedFilters[index] = Helpers.deepClone(this.tempFilter);
      } else {
        this.currentFilter = Helpers.deepClone(this.tempFilter);
        const selectedfilter = Helpers.deepClone(this.currentFilter);
        this.selectedFilters.push(Helpers.deepClone(this.currentFilter));
      }
      this.currentFilter = Helpers.deepClone(this.defaultFilterObject);
      this.updateFilterLists();
      this.showCurrentFilter = false;
    }

    if (index != undefined && index >= 0) {
      this.selectedFilters[index] = this.tempFilter;
    } else {
      this.currentFilter = this.tempFilter;
    }
    this.dropdowndata = Helpers.deepClone(this.tempFilter);
    object = this.tempFilter;
    // this.dropdownId = "";
    if (!isMultiSelect) {
      this.tempFilter = {}
    }
    if (!this.tempFilter.isOptionDropDownOpen || !this.currentFilter.isOptionDropDownOpen) {
      const defaultInput: any = document.getElementById('option_search_option_dropdown_current_filter');
      const fieldInput: any = document.getElementById('option_search_' + this.tempFilter.fieldId);
      const fieldInput2: any = document.getElementById('option_search_' + this.currentFilter.fieldId);
      if (defaultInput) defaultInput.value = '';
      if (fieldInput) fieldInput.value = '';
      if (fieldInput2) fieldInput2.value = '';
    }
  }



  onTextInputChange(event: any, filter: any) {
    const text = event.target.value
    if (text != '' && filter.valueText != text) {
      filter.isAddButtonDisabled = false;
    } else {
      filter.isAddButtonDisabled = true;
    }
    if (text == '') {
      this.isApplyButtonEnabled = false
    }

  }

  updateTextValue(event: any, object: any, index?: number) {
    this.dropdownId = "";
    event.stopPropagation();
    let filter = this.currentFilter;
    if (index == undefined || index < 0) {
      index = _.findIndex(this.selectedFilters, { filterType: object.filterType, fieldId: object.fieldId })
    }
    if (index != undefined && index >= 0) {
      filter = this.selectedFilters[index];
    }
    const value = _.get(event, 'target.parentNode.childNodes[0].value');
    if (value) {
      filter.valueText = value;

      filter.values = value.split(",");
      filter.values = _.filter(filter.values, (value: any) => {
        return value != ""
      })
      filter.isAddButtonDisabled = true;
    }
    this.toggleApplyButton(filter)
    if (index != undefined && index >= 0) {
      this.selectedFilters[index] = Helpers.deepClone(filter);
      this.tempFilter = {}
    } else {
      this.currentFilter = filter;
      const selectedfilter = Helpers.deepClone(this.currentFilter);
      this.selectedFilters.push(selectedfilter);
      this.tempFilter = {}
      this.currentFilter = Helpers.deepClone(this.defaultFilterObject);
    }
    this.updateFilterLists();
    this.showCurrentFilter = false;
  }

  submitDropdownValue(object: any, index?: number) {
    let filter = Helpers.deepClone(this.currentFilter);
    let defaultInput: any = document.getElementById('option_search_option_dropdown_current_filter');
    let fieldInput: any = document.getElementById('option_search_' + this.tempFilter.fieldId)
    if (defaultInput) {
      defaultInput.value = '';
    }
    if (fieldInput) {
      fieldInput.value = '';
    }
    if (index == undefined || index < 0) {
      index = _.findIndex(this.selectedFilters, { filterType: object.filterType, fieldId: this.tempFilter.fieldId });
    }
    if (this.indexToUpdate >= 0) {
      index = this.indexToUpdate
      this.indexToUpdate = -1
    }
    this.activeFilterId = null
    this.tempFilter.isOptionDropDownOpen = false;
    if (this.tempFilter && this.tempFilter.values && this.tempFilter.values.length) {
      if (index != undefined && index >= 0) {
        this.selectedFilters[index] = Helpers.deepClone(this.tempFilter);
      } else {
        this.currentFilter = Helpers.deepClone(this.tempFilter);
        const selectedfilter = Helpers.deepClone(this.currentFilter);
        this.selectedFilters.push(selectedfilter);
      }
      if (object.values && object.values.length && this.activeTab != 'by_hierarchy') {
        this.isApplyButtonEnabled = true;
      }
    }
    this.dropdowndata = Helpers.deepClone(this.tempFilter);
    this.tempFilter = {};
    this.currentFilter = Helpers.deepClone(this.defaultFilterObject);
    this.showCurrentFilter = false;
    this.updateFilterLists();
  }

  toggleApplyButton(filter?: any) {
    let isButtonEnabled: boolean = true;
    if (filter) {
      const appliedFilter: any = _.find(this.filterStore, { filterType: filter.filterType, fieldId: filter.fieldId });
      let c1: any = { count: filter.values.length, operator: filter.operator, text: this.sortAndConvertToString(filter.values) };
      let c2: any = { count: 0, text: '' }
      if (appliedFilter) {
        c2 = { count: appliedFilter.values.length, operator: appliedFilter.operator, text: this.sortAndConvertToString(appliedFilter.values) }
      }
      if (appliedFilter && c1.operator != c2.operator && c1.count > 0) {
        isButtonEnabled = true;
      } else if (appliedFilter && c1.count > 0 && c1.text != c2.text) {
        isButtonEnabled = true;
      } else if (c1.count <= 0 || (appliedFilter && c1.count > 0 && c1.text == c2.text)) {
        isButtonEnabled = false
      }

    } else {
      _.each(this.selectedFilters, (filter: any) => {
        if (filter.values && filter.values.length <= 0) {
          isButtonEnabled = false;
        }
      })
      if (this.currentFilter && this.currentFilter.values && this.currentFilter.values.length <= 0) {
        isButtonEnabled = false;
      }
      if (this.tempFilter && this.tempFilter.values && this.tempFilter.values.length <= 0) {
        isButtonEnabled = false;
      }
    }

    this.isApplyButtonEnabled = isButtonEnabled
  }

  sortAndConvertToString(data: any) {
    if (data && data.length) {
      let values = Helpers.deepClone(data);
      return JSON.stringify(values.sort())
    } else if (data) {
      return JSON.stringify(data)
    } else {
      return ""
    }

  }
  updateFilterLists() {
    this.filters = _.map(this.filters, (category: any) => {
      if (category.filters) {
        let isCategordisabled = false;
        let disabledCount = 0;
        let isCategordEnabled = false;
        category.filters = _.map(category.filters, (filter) => {
          const index = _.findIndex(this.selectedFilters, { fieldId: filter.field_id || filter.key });
          if (index >= 0) {
            filter.disabled = true;
            disabledCount = disabledCount + 1;
          }
          if (index < 0) {
            delete filter.disabled;
            isCategordEnabled = true;
          }
          return filter;
        })
        if (disabledCount == category.filters.length) {
          category.disabled = true;
        }
        if (isCategordEnabled) {
          delete category.disabled;
        }
      }
      return category;
    });
    this.selectedFilters = _.map(this.selectedFilters, (object: any) => {
      let filterToUpdate = Helpers.deepClone(this.filters);
      filterToUpdate = _.map(filterToUpdate, (category: any) => {
        let isCategordEnabled = false;
        category.filters = _.map(category.filters, (obj: any) => {
          if ((obj.field_id == object.fieldId) || (obj.id == object.fieldId) || (obj.key == object.fieldId)) {
            delete obj.disabled;
            isCategordEnabled = true;
          }
          return obj;
        })
        if (isCategordEnabled) {
          delete category.disabled;
        }
        return category;
      });
      object.filters = filterToUpdate;
      return object;
    });
    if (!this.selectedFilters || this.selectedFilters.length <= 0) {
      this.addMoreFilter()
    }
  }

  addMoreFilter(event?: any) {
    if (event) event.stopPropagation();
    this.isApplyButtonEnabled = false;
    let filters: any = Helpers.deepClone(this.filters);
    this.currentFilter = Helpers.deepClone(this.defaultFilterObject);
    this.currentFilter.filters = filters;
    this.showCurrentFilter = true;
  }

  removeCurrentFilter(event: any) {
    event.stopPropagation();
    this.currentFilter = {};
    this.showCurrentFilter = false;
    this.isApplyButtonEnabled = true;
    this.toggleApplyButton();
  }
  isSearchingValues: boolean = false;
  searchPossibleValues(event: any, filter: any, index?: number) {
    event.preventDefault();
    event.stopPropagation()
    this.isSearchingValues = true;
    const searchText = _.get(event, 'target.value', '').trim();
    filter.possibleValues = [];
    if (searchText != '') {
      if (filter.fieldId == "assigned_to_id_list") {
        filter = this.searchManagers(filter, searchText)
      } else if (filter.fieldId == "role_assigned_to") {
        filter = this.searchRoleBasedManager(filter, searchText);
      } else {
        filter = this.searchForValues(filter, searchText)
      }
    } else {
      setTimeout(() => {
        filter.possibleValues = []
        this.isSearchingValues = false
      }, 300);
    }
  }

  searchForValues(filter: any, searchText) {
    let params: any = {
      field_id: filter.fieldId,
      search_txt: searchText,
      size: 4
    };
    if (this.projectId) {
      params.brand_id = this.projectId;
    } else if (this.accountId) {
      params.account_id = this.accountId;
    }
    if (filter.values && filter.values.length) {
      if (!searchText || searchText == '') {
        filter.possibleValues = [];
      } else {
        filter.possibleValues = _.filter(Helpers.deepClone(filter.details), (option: any) => {
          return (option && option.value && option.value.toLowerCase().indexOf(searchText.toLowerCase()) >= 0) ? true : false;
        })
      }
    }
    this.globalFilterService.getPossibleValues(params).subscribe((response: any) => {
      let options: any = Helpers.deepClone(filter.possibleValues) || [];
      const possibleValues = _.get(response, 'data.possible_values', []);
      if (response.code == 0 && !_.isEmpty(possibleValues)) {
        _.each(possibleValues, (value: string) => {
          if (filter.values.indexOf(value) < 0) {
            options.push({
              text: value,
              value: value
            })
          }
        });
        options = _.uniqBy(options, 'value');
        filter.possibleValues = _.map(_.sortBy(options, 'text'), (option: any) => option)
      }
      this.isSearchingValues = false;
    }, (error: any) => {
      this.isSearchingValues = false;
    })
  }

  searchManagers(filter: any, searchText: string) {
    if (Helpers.brandDetails && Helpers.brandDetails._id) {
      var apiParams = {
        "brand_id": Helpers.brandDetails._id, //"588ae0d70648097645377a26", 
        "field_to_search": "email_address",
        "search_text": searchText,
        "source_type": 2, // 2 for Elastic Search
        "page_number": 1,
        "limit": 10,
        "search_for_verified_mgrs": true,
        "search_type": 1, // Get all the manager who belongs to the brand
        // "account_id": Utils.getAccountId()
      }
      if (filter.values && filter.values.length) {
        if ((!searchText || searchText == '')) {
          filter.possibleValues = Helpers.deepClone(filter.details)
        } else {
          filter.possibleValues = _.filter(Helpers.deepClone(filter.details), (option: any) => {
            return (option && option.text && option.text.indexOf(searchText) >= 0) ? true : false;
          })
        }
      }
      this.globalFilterService.getManagersList(apiParams).subscribe((response: any) => {
        let options: any = Helpers.deepClone(filter.possibleValues)
        const possibleValues = _.get(response, 'data.managers', []);
        if (response.code == 0 && !_.isEmpty(possibleValues)) {
          _.each(possibleValues, (manager: any) => {
            if (manager._id && filter.values.indexOf(manager._id) < 0) {
              options.push({
                text: manager.email_address,
                value: manager._id
              })
            }
          });
          options = _.uniqBy(options, 'value');
          filter.possibleValues = _.map(_.sortBy(options, 'text'), (option: any) => option)
        }
        this.isSearchingValues = false;
      })
    } else {
      this.isSearchingValues = false;
    }

  }

  searchRoleBasedManager(filter: any, searchText: string) {
    if (Helpers.brandDetails && Helpers.brandDetails._id) {
      let apiParams = {
        "brand_id": Helpers.brandDetails._id,
        "level": (filter.operator && filter.operator != '') ? filter.operator : null,
        "type": 1, // Get roles based on levels
        "page_number": 1,
        "search_text": searchText,
        "limit": 10
      }
      if (filter.values && filter.values.length) {
        if ((!searchText || searchText == '')) {
          filter.possibleValues = Helpers.deepClone(filter.details)
        } else {
          filter.possibleValues = _.filter(Helpers.deepClone(filter.details), (option: any) => {
            return (option && option.text && option.text.indexOf(searchText) >= 0) ? true : false;
          })
        }
      }
      this.globalFilterService.getRolebasedManagersList(apiParams).subscribe((response: any) => {
        let options: any = Helpers.deepClone(filter.possibleValues)
        const possibleValues = _.get(response, 'data.dat', []);
        if (response.code == 0 && !_.isEmpty(possibleValues)) {
          _.each(possibleValues, (manager: any) => {
            if (manager._id && filter.values.indexOf(manager) < 0) {
              options.push({
                text: manager,
                value: manager
              })
            }
          });
          options = _.uniqBy(options, 'value');
          filter.possibleValues = _.map(_.sortBy(options, 'text'), (option: any) => option)
        }
        this.isSearchingValues = false;
      })
    } else {
      this.isSearchingValues = false;
    }
  }
  searchText: string = '';
  searchSavedFilter(event: any) {
    event.stopPropagation()
    const text = _.get(event, 'target.value')
    this.searchText = text;
    this.savedFiltersList = _.filter(Helpers.deepClone(this.savedFilters), (filter: any) => {
      return (filter.name.toLowerCase().indexOf(text.toLowerCase()) >= 0);
    })
  }
  activeFilterId: any;
  applySavedFilter(data: any) {
    let accessFilterIds: any = []
    this.selectedFilters = _.filter(this.selectedFilters, (filter: any) => {
      if (filter.isAccessLevelFilter == true) {
        accessFilterIds.push(filter.fieldId)
        return true;
      } else {
        return false;
      }
    });

    if (data && data.filters && !_.isEmpty(data.filters)) {
      this.activeFilterId = data._id
      _.each(data.filters, (value: any, key: string) => {
        _.each(value, (details: any, fieldId: String) => {
          if (details && details.group_id && details.is_question_as_tag) {
            return;
          }
          let filter_type: string = key;
          if (key == "tag_filter") {
            filter_type = "transaction_filter";
          }
          if (key == "question_filter" && details && details.is_question_as_tag) {
            filter_type = "transaction_filter";
          }
          const categoryIndex = _.findIndex(this.filters, { filterType: filter_type });
          if (categoryIndex >= 0) {
            const category = Helpers.deepClone(this.filters[categoryIndex]);
            if (category && !_.isEmpty(category.filters)) {

              if (accessFilterIds.indexOf(fieldId) < 0) {
                const filterObject: any = Helpers.deepClone(this.defaultFilterObject);
                filterObject.filterType = category.filterType;
                filterObject.filterText = category.label;
                filterObject.filterType = category.filterType;
                filterObject.isMultiSelect = (category.filterType == "question_filter") ? true : false;
                filterObject.filterText = category.label;
                filterObject.operators = (category.operators) ? category.operators : [];
                filterObject.possibleValues = [];
                if (filterObject.filterType == "text_filter") {
                  fieldId = 'comments'
                  if (details.contains && details.contains.length) {
                    details.action = 'contains'
                    filterObject.values = details.contains;
                    filterObject.valueText = details.contains.join(',')
                  } else if (details.doesNotContains && details.doesNotContains.length) {
                    details.action = 'doesNotContains'
                    filterObject.values = details.doesNotContains;
                    filterObject.valueText = details.doesNotContains.join(',')
                  }
                  filterObject.field_id_list = details.field_id_list;
                  filterObject.isAddButtonDisabled = true;
                }
                let fieldIndex = _.findIndex(category.filters, (fieldDetails: any) => {
                  return (fieldDetails.field_id == fieldId || fieldDetails.key == fieldId);
                });
                if (fieldIndex >= 0) {
                  const fieldDetails = Helpers.deepClone(category.filters[fieldIndex])
                  filterObject.fieldId = fieldDetails.field_id || fieldDetails.key;
                  filterObject.fieldText = fieldDetails.text || fieldDetails.name;
                  filterObject.fieldType = fieldDetails.type;
                  filterObject.fieldDefinitionType = fieldDetails.field_type;
                  filterObject.isQuestionAsTagFilter = !!(details?.is_question_as_tag || fieldDetails.isQuestionAsTagFilter || fieldDetails.field_type == "response" || fieldDetails.field_type == "interaction");
                  filterObject.isSearchEnabled = filterObject.isQuestionAsTagFilter ? false : !!fieldDetails.isSearchEnabled;
                  if (category.filterType == "action_filter") {
                    filterObject.idToPrepend = fieldDetails.id;
                  }

                  if (fieldDetails.options && fieldDetails.options.length) {
                    filterObject.possibleValues = _.map(fieldDetails.options, (option: any) => {
                      option.text = option.label;
                      return option;
                    });
                  } else if (fieldDetails.possibleValues && fieldDetails.possibleValues.length) {
                    filterObject.possibleValues = Helpers.deepClone(fieldDetails.possibleValues);
                  } else if (details.details && details.details.length) {
                    filterObject.possibleValues = _.concat(filterObject.possibleValues, details.details);
                  } else if (category.filterType == 'transaction_filter' && details.values && details.values.length) {
                    filterObject.possibleValues = _.map(details.values, (value: any) => {
                      return {
                        text: value,
                        value: value
                      }
                    });
                  }

                  if (fieldDetails.operators && fieldDetails.operators.length) {
                    filterObject.operators = Helpers.deepClone(fieldDetails.operators);
                  }
                  if (fieldDetails.type == "multi-select" || fieldDetails.type == "single-select") {
                    filterObject.operators = _.filter(filterObject.operators, (op: any) => {
                      return (op.value == 'eq' || op.value == 'ne')
                    })
                  }

                  if (filterObject.operators.length) {
                    const opDetail = _.find(filterObject.operators, { value: details.action });
                    filterObject.operator = opDetail.value;
                    filterObject.operatorText = opDetail.text;
                    filterObject.isMultiSelect = (opDetail.value == 'eq' || opDetail.value == 'ne') ? true : false
                  }

                  if (filterObject.possibleValues.length) {
                    const labels: any = [];
                    _.each(filterObject.possibleValues, (value: any) => {
                      if (details.values.indexOf(value.value) >= 0) {
                        labels.push(value.text);
                        filterObject.details.push(value);
                      }
                    })
                    filterObject.labels = labels;
                    filterObject.values = Helpers.deepClone(details.values);
                    filterObject.valueText = labels.join(",");
                  }

                  // Check if the question is of a specific component type and if extended rater type is 4
                  if (fieldDetails.field_id == "primary_rating" && fieldDetails?.component_type == 'ltms-nps-five-star-rater' && Helpers.brandDetails?.extended_rater_type === 4 && (!_.isEmpty(Helpers.brandDetails.extended_rating_mapper))) {
                    // Get new operator items
                    filterObject.operators = _.filter(filterObject.operators, (op: any) => {
                      return (op.value == 'eq' || op.value == 'ne')
                    })
                    // Set original values for further use
                    filterObject.componentType = fieldDetails?.component_type;
                    filterObject.mappedLabels = filterObject?.labels;
                    filterObject.mappedValues = filterObject?.values;
                    filterObject.mappedValueText = filterObject?.valueText;

                    let options: any = [];
                    let originalOptions: any = filterObject.possibleValues;
                    filterObject.originalPossibleValues = originalOptions;
                    for(let i in originalOptions) {
                      options.push(this.extenderRatingMapper.getNewOptionsForExtendedRaterType(originalOptions[i], fieldDetails?.main_rater_type));
                      filterObject.possibleValues = _.sortBy(this.extenderRatingMapper.removeDuplicateOptionsOfExtendedRater(options), 'value').reverse();
                    }

                    // Step 1: Get the dynamic mapping for the current rater type
                    const newExtendedRaterMapping: Record<string, number> = this.extenderRatingMapper.getDynamicExtendedRaterMapping(fieldDetails?.main_rater_type);
                    const selectedValues = details.values;
                    const mappedValues: number[] = [];
                    // Step 2: Reverse-map selected values to their original keys
                    selectedValues.forEach(selected => {
                      for (const [key, value] of Object.entries(newExtendedRaterMapping)) {
                        if (parseInt(key) === parseInt(selected)) {
                          if(mappedValues.indexOf(Number(value)) == -1) {
                            mappedValues.push(Number(value));
                          }
                        }
                      }
                    });
                    // Step 3: Get the values & text representation of the mapped values
                    const obj = this.extenderRatingMapper.getExtendedRaterTextValues(mappedValues, filterObject, true);
                    filterObject.labels = obj?.mappedNewLabels;
                    filterObject.values = obj?.mappedNewValues;
                    filterObject.valueText = obj?.mappedNewValueText;
                  }

                  if (filterObject.values.length) {
                    filterObject.filters = Helpers.deepClone(this.filters);
                    this.selectedFilters.push(filterObject);
                    this.updateFilterLists();
                  }
                }
              }
            }
          }
        })
      });
    }
    if (this.selectedFilters.length) {
      this.applyGlobalFilter(false);
      this.savedFiltersList = _.map(this.savedFiltersList, (filter: any) => {
        if (filter._id == data._id) {
          filter.isActive = true;
        } else {
          filter.isActive = false;
        }
        return filter;
      })
    }

    this.closeSideBar();
  }

  removeSavedFilter(filter: any) {
    if (filter && (filter.account_id || filter.brand_id) && filter._id) {
      let params: any = {
        filter_id: filter._id
      };
      if (filter.is_account_filter && filter.account_id) {
        params.account_id = filter.account_id;
      }
      if (!filter.is_account_filter && filter.brand_id) {
        params.brand_id = filter.brand_id;
      }
      this.globalFilterService.removeSaveFilter(params).subscribe((response: any) => {
        if (_.get(response, 'data.code') == 0) {
          this.savedFilters = _.filter(this.savedFilters, (object: any) => {
            return (object._id != filter._id);
          })
          this.savedFiltersList = Helpers.deepClone(this.savedFilters);
          Helpers.smallAlertBox('Success', 'Saved filter successfully removed.', 'Success')
        } else {
          Helpers.smallAlertBox('Error', 'Error while deleting saved filter.', 'error')
        }

      }, (error: any) => {
        Helpers.smallAlertBox('Error', 'Error while deleting saved filter.', 'error')
        console.error("Error : While deleting saved filter", error)
      })
    }

  }


  closeSaveFilterModal() {
    this.isSaveFilterModalOpen = false;
  }

  openSaveFilterModel() {
    if (this.appliedGlobalFilter.length > 0 && this.isEditAccess) {
      this.isSaveFilterModalOpen = true;
    } else {
      Helpers.smallAlertBox("Permission denied", "you don't have permision to save applied filters", 'warn', 3000)
    }

  }

  saveActiveFilters() {
    if (this.appliedGlobalFilter && this.appliedGlobalFilter.length) {
      const formatedFilters = this.globalFilterService.getFormatedUniversalFilter(this.appliedGlobalFilter);
      if ((this.projectId || this.accountId) && this.filterName != "" && !_.isEmpty(formatedFilters)) {
        let params: any = {
          name: this.filterName,
          filters: formatedFilters
        }
        if (this.projectId) {
          params.brand_id = this.projectId;
          params.is_account_filter = false;
        } else if (this.accountId) {
          params.account_id = this.accountId;
          params.is_account_filter = true;
        }
        this.globalFilterService.saveFilter(params).subscribe((response: any) => {
          this.isSaveFilterModalOpen = false;
          if (_.get(response, 'data.code') == 0 && _.get(response, 'data.insertedFilter')) {
            const filter = _.get(response, 'data.insertedFilter')
            this.savedFilters.push(filter)
            this.savedFiltersList = Helpers.deepClone(this.savedFilters);
            Helpers.smallAlertBox('Success', "Applied filter saved successfully.", 'Success')
          } else {
            Helpers.smallAlertBox('Error', "Error while saving filters.", 'error')
          }

        }, (error: any) => {
          this.isSaveFilterModalOpen = false;
          Helpers.smallAlertBox('Error', "Error while saving filters.", 'error')
          console.log("Error: Error while saving filters", error);
        })
      }
    }

  }

  clearActiveFilters() {
    const accessLevelFilters = _.find(this.selectedFilters, { isAccessLevelFilter: true })
    if (accessLevelFilters && !_.isEmpty(accessLevelFilters)) {
      this.appliedGlobalFilter = _.filter(this.appliedGlobalFilter, (filter: any) => {
        return filter.isAccessLevelFilter == true
      })
      this.selectedFilters = Helpers.deepClone(this.appliedGlobalFilter);
      const formatedFilters = this.globalFilterService.getFormatedUniversalFilter(this.appliedGlobalFilter);
      this.globalFilterService.storeUniversalFilters({ filterId: null, isAppliedFromAccount: this.isAccount, filters: this.appliedGlobalFilter });
      this._helpers.setUniversalFilters(formatedFilters);
    } else {
      const filterMap = this.globalFilterService.getGolbalFilters();
      this.filters = Object.values(filterMap);
      this.appliedGlobalFilter = [];
      this.selectedFilters = [];
      this.currentFilter = Helpers.deepClone(this.defaultFilterObject);
      this.currentFilter.filters = Object.values(this.filters);
      this.showCurrentFilter = true;
      this.activeFilterId = null;
      this.globalFilterService.storeUniversalFilters({});
      this._helpers.setUniversalFilters({});
      this.savedFiltersList = _.map(this.savedFiltersList, (filter: any) => {
        filter.isActive = false;
        return filter
      })
    }

  }
  isFilterNameExistes: boolean = false;
  onFilterNameChange(event: any) {
    let text = _.get(event, 'target.value');
    text = text.trim();
    const list = _.filter(this.savedFilters, (filter: any) => {
      return filter.name.toLowerCase() == text.toLowerCase();
    })
    if (list && list.length) {
      this.isFilterNameExistes = true;
    } else {
      this.isFilterNameExistes = false;
    }
    if (text.length > 3) {
      this.filterName = text;
      this.enableSaveButton = true;
    } else {
      this.filterName = "";
      this.enableSaveButton = false;
    }
  }
  removeFilter(event, filter: any) {
    event.stopPropagation();
    const oldCount = this.selectedFilters.length
    this.selectedFilters = _.filter(this.selectedFilters, (object: any) => {
      return !(object.filterType == filter.filterType && object.fieldId == filter.fieldId);
    })
    this.filterStore = _.filter(this.filterStore, (object: any) => {
      return !(object.filterType == filter.filterType && object.fieldId == filter.fieldId);
    })
    this.activeFilterId = null;
    this.updateFilterLists();
    this.isApplyButtonEnabled = (this.selectedFilters && (this.selectedFilters.length != oldCount)) ? true : false;
  }

  clone(data: any) {
    return JSON.parse(JSON.stringify(data));
  }
  isEllipsisActive(id: string) {
    const el = document.getElementById(id);
    if (el) {
      return (el.offsetWidth < el.scrollWidth)
    } else {
      return false
    }

  }


  huddlefilters: any = [
    {
      id: 'escalation'
    }, {
      id: 'spotlights'
    }, {
      id: 'actions'
    }
  ]
  filterMap = {
    "action_status_list": "tag_ltms_huddle_suggestions_for_process_imporvement_status-display_field_1"
  }
  defaultHuddleFilter: any = {
    filterids: {
      "escalation": {},
      "spotlights": {},
      "actions": {}
    },
    filter: {
      "escalation": {},
      "spotlights": {},
      "actions": {}
    }
  }
  appliedhuddleFilter: any = {}
  huddleFilterStore: any = {}
  isHuddleApplyButtonEnabled: boolean = false
  isHuddleClearButtonEnabled: boolean = false;
  initHuddleFilter() {
    this.huddlefilters = [
      {
        "id": 'escalation',
        "name": _.get(Helpers, "brandDetails.action_management_configuration.huddle.modules.escalations.title") || "Suggestions for Process Improvement",
        "hasFilter": true,
        "list": [{
          "filter_key": 'action_status_list',
          "filters": _.get(Helpers, "brandDetails.status_list_for_huddle", [])
        }]
      }, {
        "id": 'spotlights',
        "name": _.get(Helpers, "brandDetails.action_management_configuration.huddle.modules.spotlights.title") || "Employee Spotlight",
        "hasFilter": false,
        "list": []
      }, {
        "id": 'actions',
        "name": _.get(Helpers, "brandDetails.action_management_configuration.huddle.modules.actions.title") || "Action Plans",
        "hasFilter": false,
        "list": []
      }
    ]
    this.huddleFilterStore = Helpers.deepClone(this.defaultHuddleFilter)
    this.appliedhuddleFilter = Helpers.deepClone(this.defaultHuddleFilter)

    let appliedFilter: any = this.globalFilterService.gethuddleFilters()
    if (appliedFilter && !_.isEmpty(appliedFilter)) {
      this.appliedhuddleFilter = appliedFilter;
    }
    if (appliedFilter && !_.isEmpty(appliedFilter) && this.generateHash(this.huddleFilterStore) != this.generateHash(appliedFilter)) {
      this.isHuddleClearButtonEnabled = true;
    }

    this.huddleFilterStore = Helpers.deepClone(this.appliedhuddleFilter)
  }

  toggleHuddleFilter(event: any, tabKey: string, filter: any, filterKey: string) {
    event.preventDefault()
    let filterFieldId: any = this.filterMap[filterKey]
    if (filterFieldId) {
      const filterid = filter.field_id || filter.uuid;
      const filterValue = filter.name;
      let appliedIdList = _.get(this.appliedhuddleFilter, 'filterids.' + tabKey + '.' + filterFieldId);
      let appliedValueList = _.get(this.appliedhuddleFilter, 'filter.' + tabKey + '.' + filterFieldId);
      if (!appliedIdList) {
        appliedIdList = []
      }
      if (!appliedValueList) {
        appliedValueList = []
      }

      if (appliedIdList.indexOf(filterid) < 0) {

        appliedIdList.push(filterid);
        appliedValueList.push(filterValue);
      } else {
        appliedIdList = _.filter(appliedIdList, (val) => {
          return val != filterid;
        })
        appliedValueList = _.filter(appliedValueList, (val) => {
          return val != filterValue;
        })
      }
      if (appliedIdList && appliedIdList.length) {
        this.appliedhuddleFilter.filterids[tabKey][filterFieldId] = appliedIdList;
        this.appliedhuddleFilter.filter[tabKey][filterFieldId] = appliedValueList;
      } else {
        delete this.appliedhuddleFilter.filterids[tabKey][filterFieldId];
        delete this.appliedhuddleFilter.filter[tabKey][filterFieldId];
      }
    }
    this.isHuddleApplyButtonEnabled = this.toggleHuddleApplyButton()
  }

  toggleHuddleApplyButton() {
    if (this.generateHash(this.huddleFilterStore) != this.generateHash(this.appliedhuddleFilter)) {
      return true
    } else {
      return false
    }
  }

  private generateHash(obj): string {
    if (obj !== undefined && !_.isEmpty(obj)) {
      return _.map(obj, (val, key) => { return `${key}-${JSON.stringify(val)}` }).join('|'); // Simple hash function
    } else {
      return 'NOHASHED'
    }
  }

  isOptionChecked(tabKey: string, filter: any, filterKey: string) {
    let filterFieldId: any = this.filterMap[filterKey];
    if (filterFieldId) {
      let filterId = filter.field_id || filter.uuid;
      let idList = _.get(this.appliedhuddleFilter, 'filterids.' + tabKey + '.' + filterFieldId)
      if (idList && idList.length && idList.indexOf(filterId) >= 0) {
        return true;
      } else {
        return false;
      }

    } else {
      return false
    }
  }

  applyHuddleFilter() {
    if (this.appliedhuddleFilter && !_.isEmpty(this.appliedhuddleFilter) && this.generateHash(this.defaultHuddleFilter) != this.generateHash(this.appliedGlobalFilter)) {
      this.globalFilterService.savehuddleFilters(this.appliedhuddleFilter);
      this._helpers.setHuddleFilter(this.appliedhuddleFilter.filter)
      this.closeSideBar()
    } else {
      this.clearHuddlFiter()
    }

  }
  cancelHuddleFIlter() {
    this.appliedhuddleFilter = this.globalFilterService.gethuddleFilters()
    this.closeSideBar()
  }

  clearHuddlFiter() {
    this.globalFilterService.savehuddleFilters({});
    this._helpers.setHuddleFilter({})
    this.closeSideBar()
  }

}